import { get } from "lodash"
import ActionTypes from "../../enums/ActionTypes"
import { API_SERVER_PLANNING_PROCESS } from "../../constants/api"
import { APIGenericSequence } from "../api"
import { TimelineSagaState } from "./TimelineSagaTypes"

const endPointFetch = `${API_SERVER_PLANNING_PROCESS}/planningTimelineRawFlat`

export default [
  APIGenericSequence({
    actionType: ActionTypes.TIMELINE_DATA_FETCH,
    prepareUrl: (endpoint: string, _: unknown, state: TimelineSagaState) => {
      const filterDateRange = get(state, "ui.timelines.filterDateRange")
      const { fromDate, toDate } = filterDateRange
      const params = `?fromDate=${fromDate}&toDate=${toDate}&includeProgress=true`
      return endpoint + params
    },
    endPoint: endPointFetch,
  }),
]
